import { IconOpenEye } from "../Icons/IconOpenEye";
import { IconCloseEye } from "../Icons/IconCloseEye";

export default function AmountVisibleToggle({
  value = "",
  visible = false,
  onVisibleChange = () => {},
  className = "",
  height = 28,
  children,
  ...props
}) {
  const toggleVisible = () => {
    if (typeof onVisibleChange === "function") {
      onVisibleChange(!visible);
    }
  };

  const renderWhenVisible = () => {
    if (value) {
      return <span className={className}>{value}</span>;
    }
    return children;
  };

  return (
    <div {...props}>
      <div className="flex items-center gap-2">
        <div style={{
          height: height,
          lineHeight: `${height}px`,
        }}>{visible ? renderWhenVisible() : "******"}</div>
        <div className="cursor-pointer" onClick={toggleVisible}>
          {visible ? <IconOpenEye /> : <IconCloseEye />}
        </div>
      </div>
    </div>
  );
}
